const NAMED_ENTITIES: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
};

function decodeCodePoint(code: number): string | null {
  if (!Number.isInteger(code) || code < 0 || code > 0x10ffff) return null;
  return String.fromCodePoint(code);
}

function decodeHtmlEntitiesOnce(value: string): string {
  return value
    .replace(/&#x([0-9a-fA-F]+);/g, (match, hex: string) => decodeCodePoint(parseInt(hex, 16)) ?? match)
    .replace(/&#(\d+);/g, (match, dec: string) => decodeCodePoint(parseInt(dec, 10)) ?? match)
    .replace(/&([a-zA-Z]+);/g, (match, name: string) => NAMED_ENTITIES[name.toLowerCase()] ?? match);
}

/**
 * Turns HTML entities such as `&#x2f;` into the matching characters.
 * Runs a few passes so double-encoded model output still becomes plain text.
 */
export function decodeHtmlEntities(value: string): string {
  if (!value.includes('&')) return value;

  let current = value;
  for (let i = 0; i < 3; i += 1) {
    const next = decodeHtmlEntitiesOnce(current);
    if (next === current) break;
    current = next;
  }
  return current;
}

export function decodeHtmlEntitiesDeep<T>(value: T): T {
  if (typeof value === 'string') {
    return decodeHtmlEntities(value) as T;
  }
  if (Array.isArray(value)) {
    return value.map((item) => decodeHtmlEntitiesDeep(item)) as T;
  }
  if (value && typeof value === 'object') {
    const entries = Object.entries(value).map(([key, item]) => [key, decodeHtmlEntitiesDeep(item)]);
    return Object.fromEntries(entries) as T;
  }
  return value;
}
